// Constantes globais do sistema BeeStock

export const TRANSFER_TYPES = {
  ADDRESS: 'addressTransfer',
  WAVE_IN: 'waveTransferIn',
  WAVE_OUT: 'waveTransferOut',
};
